module.exports = __webpack_public_path__ + "img/icon-exchange-01.svg";